<template>
  <div class="container">
    <div class="weui-msg">
        <div class="weui-msg__icon-area"><i class="weui-icon-success weui-icon_msg"></i></div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">订单已临时保存</h2>
            <p class="weui-msg__desc">感谢使用到家<br>继续完成订单，需要注册或登录账号</p>
        </div>
        <div class="btn-box">
          <div class="btn active" @click="goto('/reg')">立即注册 / 登录</div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'order-login',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:30px;
}

.container /deep/{
  .weui-icon-success{
    color:#fe9567;
  }
  .weui-btn_primary{
    background:#fe9567;
    color:#fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/order/order-login.vue